// Utilitários para corrigir problemas de codificação de caracteres

/**
 * Corrige problemas de codificação UTF-8 em strings
 * @param {string} str - String que pode ter problemas de codificação
 * @returns {string} - String corrigida
 */
export const fixEncoding = (str) => {
  if (typeof str !== 'string') return str;
  
  try {
    // Se a string contém caracteres mal codificados, tenta decodificar
    if (str.includes('�') || str.includes('Ã') || str.includes('ï¿½')) {
      // Tenta corrigir problemas comuns de codificação
      return str
        .replace(/Ã¡/g, 'á')
        .replace(/Ã£/g, 'ã')
        .replace(/Ã©/g, 'é')
        .replace(/Ãª/g, 'ê')
        .replace(/Ã­/g, 'í')
        .replace(/Ã³/g, 'ó')
        .replace(/Ãµ/g, 'õ')
        .replace(/Ãº/g, 'ú')
        .replace(/Ã§/g, 'ç')
        .replace(/Ã/g, 'Á')
        .replace(/Ã/g, 'Ã')
        .replace(/Ã/g, 'É')
        .replace(/Ã/g, 'Ê')
        .replace(/Ã/g, 'Í')
        .replace(/Ã/g, 'Ó')
        .replace(/Ã/g, 'Õ')
        .replace(/Ã/g, 'Ú')
        .replace(/Ã/g, 'Ç')
        .replace(/�/g, 'á'); // Caractere de substituição comum
    }
    
    return str;
  } catch (error) {
    return str;
  }
};

/**
 * Processa um objeto recursivamente para corrigir problemas de codificação
 * @param {any} obj - Objeto que pode conter strings com problemas de codificação
 * @returns {any} - Objeto com strings corrigidas
 */
export const fixObjectEncoding = (obj) => {
  if (typeof obj === 'string') {
    return fixEncoding(obj);
  }
  
  if (Array.isArray(obj)) {
    return obj.map(fixObjectEncoding);
  }
  
  if (obj && typeof obj === 'object') {
    const fixedObj = {};
    for (const [key, value] of Object.entries(obj)) {
      fixedObj[key] = fixObjectEncoding(value);
    }
    return fixedObj;
  }
  
  return obj;
};